import Vue from 'vue';
export default {
  state: {
    cartEvents: [],
    cartProducts: {},
    couponProducts: {
      percentage: {},
      promo: {}
    },
    feePayments: [],
    reservePayments: false,
    returnPageFeePayment: false,
  },
  getters: {
    cartProducts(state) {
      return Object.values(state.cartProducts);
    },
    cartProductsMeta(state) {
      const arr = Object.values(state.cartProducts);

      if (!arr.length) return {};
      const coupon = state.couponProducts;
      const arrPromo = [];
      const totalProducts = arr.map((el) => el.quantity).reduce((a, b) => a + b);
      let currency;
      arr.forEach(elem => {
        if (elem.currency) {
          currency = elem.currency.symbol;
        }
      });
      const storeId = arr[0].storeId;
      const t = arr.map((el) => {
        let result = 0;
        if (el.offerPrice) {
          result = el.quantity * el.offerPrice;
        } else {
          result = el.quantity * el.price;
        }
        return result;
      });
      const subtotal = t.reduce((a, b) => a + b);
      let discount = 0;
      arr.forEach((value) => {
        for (let i = 0; i < value.quantity; i += 1) {
          const item = { ...value };
          item.quantity = 1;
          arrPromo.push(item);
        }
      });

      if (coupon.promo.code && totalProducts >= 3) {
        const arrPercentage = [...arrPromo];
        state.couponProducts.promo.active = true;
        do {
          arrPercentage.sort((a, b) => a.price - b.price);
          discount += arrPercentage[0].offerPrice || arrPercentage[0].price;

          arrPercentage.splice(0, 1);
          arrPercentage.splice(arrPercentage.length - 2, 2);
        } while (arrPercentage.length >= 3);

        if (coupon.percentage.code && arrPercentage.length > 0) {
          arrPercentage.forEach((per) => {
            state.couponProducts.percentage.active = true;
            const disPer = (per.price * coupon.percentage.percentage) / 100;
            discount += disPer;
          });
        }
      } else if (coupon.percentage.code) {
        state.couponProducts.percentage.active = true;
        discount = (subtotal * coupon.percentage.percentage) / 100;
      }
      return {
        subtotal,
        discount: discount.toFixed(2),
        total: (subtotal - discount).toFixed(2),
        totalProducts,
        currency,
        storeId
      };
    },
    cartEvents(state) {
      if (!state.cartEvents.length) return [];
      const arrByEvent = state.cartEvents.slice().groupBy('adhId');
      return Object.keys(arrByEvent).map((key) => {
        const firstEl = arrByEvent[key][0];
        return {
          activityId: firstEl.activityId,
          adhId: parseInt(key, 0),
          title: firstEl.title,
          imageUrl: firstEl.imageUrl,
          day: firstEl.date,
          hour: `${firstEl.timeStart} - ${firstEl.timeEnd}`,
          types: arrByEvent[key]
        };
      });
    },
    dataEventsSend(state, getters) {
      const cpCartp = getters.cartEvents.slice();
      return cpCartp.map((item) => {
        const types = item.types.map((type) => {
          const notVenue = type.type !== 'venue';
          return {
            ticketTypeId: type.ticketTypeId,
            quantity: notVenue ? type.value : type.value.split(',').length,
            seats: notVenue ? null : type.value.toUpperCase()
          };
        });
        return {
          id: item.activityId,
          activity_date_hour_id: item.adhId,
          types
        };
      });
    },
    cartEventsMeta(state) {
      if (!state.cartEvents.length) return {};
      let total = 0;
      let totalProducts = 0;
      state.cartEvents.forEach((item) => {
        const val = item.type !== 'venue' ? item.value : item.value.split(',').length;
        totalProducts += val;
        total += item.price * parseInt(val, 0);
      });
      // if(total > 0) {
      //   total += parseInt(this.paymentCommission);
      // }
      const currencyIso = state.cartEvents[0].currency;
      const currency = currencyIso === 'PEN' ? 'S/' : '$';

      if (state.reservePayments === true && state.feePayments.length !== 0) {
        total = state.feePayments.map((elem) => elem.amount).reduce((prev, curr) => prev + curr, 0);
      }

      return {
        total: total.toFixed(2),
        totalProducts,
        currencyIso,
        currency
      };
    }
  },
  mutations: {
    cleanCartProducts(state) {
      Vue.set(state, 'cartProducts', {});
    },
    setUpdateCartProducts(state, payload) {
      let size = []
      if (payload.variations) {
        size = payload.variations.searchCode.split(':');
      } else {
        size = ['', ''];
      }
      let productId = payload.id + size[1]
      Vue.set(state.cartProducts, productId, payload);
    },
    removeItemCartProducts(state, idProduct) {
      Vue.delete(state.cartProducts, idProduct);
    },
    // events
    cleanCartEvents(state) {
      Vue.set(state, 'cartEvents', []);
    },
    updateCartEvents(state, payload) {
      Vue.set(state, 'cartEvents', payload);
    },
    // coupon product
    cleanCouponProducts(state) {
      Vue.set(state, 'couponProducts', {});
    },
    updateCouponProducts(state, payload) {
      if (payload.type === 'percentage') {
        Vue.set(state.couponProducts, 'percentage', payload.value);
      } else if (payload.type === '3x2') {
        Vue.set(state.couponProducts, 'promo', payload.value);
      } else if (payload.type === 'full') {
        Vue.set(state, 'couponProducts', { percentage: payload.value, promo: {} });
      }
    },
    UPDATE_FEE_PAYMENTS(state, payload) {
      state.feePayments = payload;
    },
    CHANGE_RESERVE_PAYMENTS(state, payload) {
      state.reservePayments = payload;
    },
    CHANGE_RETURN_PAGE_FEE_PAYMENT(state, payload) {
      state.returnPageFeePayment = payload;
    },
    CHANGE_COUPON_EVENT(state, payload) {
      const eventIndex = state.cartEvents.findIndex(elem => elem.activityId === payload.activityId && elem.adhId === payload.adhId);
      if (eventIndex != -1) {
        state.cartEvents[eventIndex].coupon = payload.code
      } else {
        for (const elem of state.cartEvents) {
          if (elem.activityId === payload.activityId && elem.adhId === payload.adhId) {
            elem.coupon = '';
          }
        }
      }

    }
  },
  actions: {
    updateCartProducts({ commit }, payload) {
      commit('setUpdateCartProducts', payload);
    },
    updateFeePayments({ commit }, payload) {
      commit('UPDATE_FEE_PAYMENTS', payload);
    },
    changeReservePayments({ commit }, payload) {
      commit('CHANGE_RESERVE_PAYMENTS', payload);
    },
    returnPageFeePayment({ commit }, payload) {
      commit('CHANGE_RETURN_PAGE_FEE_PAYMENT', payload);
    },
    changeCouponEvent({ commit }, payload) {
      commit('CHANGE_COUPON_EVENT', payload);
    },
  }
};
